import { Check, ExpandMore } from '@mui/icons-material';
import { Button, Grid, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

CategoryPicker.propTypes = {
  onChange: PropTypes.func,
  categories: PropTypes.array,
  value: PropTypes.array,
};

export default function CategoryPicker({ categories, value, onChange }) {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const buttonLabel = value.length === categories.length ? 'all' : value.length > 1 ? `${value[0].name}(+${value.length - 1})` : value.length === 1 ? value[0].name : '_____';

  return (
    <>
      <Typography variant="caption">
        Review <Button size="small" color="primary" endIcon={<ExpandMore />} onClick={handleClick}>{buttonLabel}</Button> categories <Tooltip title="required">*</Tooltip>
      </Typography>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ list: { 'aria-labelledby': 'basic-button' } }}
      >
        <MenuItem
          dense
          key="all"
          onClick={() => value.length === categories.length ? onChange([]) : onChange(categories)}
        >
          {value.length === categories.length ? 'Deselect all' : 'All'}
        </MenuItem>
        {categories?.sort((a, b) => {
          const aSelected = value.some(v => v.id === a.id);
          const bSelected = value.some(v => v.id === b.id);
          if (aSelected !== bSelected) return aSelected ? -1 : 1;
          return a.name.localeCompare(b.name);
        }).map(c => {
          const checked = value.some(v => v.id === c.id);
          return <MenuItem dense key={c.id}
            onClick={() => {
              onChange(checked ? value.filter(prevCat => prevCat.id !== c.id) : [...value, c])
            }}>
            <Grid container direction="row" sx={{ justifyContent: "space-between" }}>
              <div>{c.name}</div> <div style={{ visibility: checked ? 'visible' : 'hidden' }}>
                <Check fontSize="inherit" color="primary" /></div>
            </Grid>
          </MenuItem>
        }
        )}
      </Menu >
    </>
  );
}

